// extracted by mini-css-extract-plugin
export default {"layout":"photoView_layout__CdV8c","imgView":"photoView_imgView__OTKwB","error":"photoView_error__z5LQz","deleteButton":"photoView_deleteButton__PAvr8"};